import React, { useState } from "react";
import {
  Box,
  Container,
  Flex,
  Heading,
  HStack,
  Tag,
  Text,
  SimpleGrid,
  Image,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";

function SponsorsPartners() {
  const [active, setActive] = useState("sponsors");

  const accent = "#16A34A";
  const accent2 = "#22C55E";

  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const titleColor = useColorModeValue("#0F172A", "white");
  const subColor = useColorModeValue("gray.700", "gray.300");
  const pageBg = useColorModeValue("gray.50", "rgba(255,255,255,0.02)");

  const heroBg = useColorModeValue(
    "radial-gradient(1000px 420px at 12% 0%, rgba(34,197,94,0.18), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(22,163,74,0.14), transparent 60%), linear-gradient(180deg, rgba(2,6,23,0.02), rgba(2,6,23,0.00))",
    "radial-gradient(1000px 420px at 12% 0%, rgba(34,197,94,0.20), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(22,163,74,0.14), transparent 60%), linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.00))"
  );

  const sponsors = [
    "sponsors 1.png",
    "sponsors 2.png",
    "Mitacs Media Kit_ Resources for Media____.png",
    "sponsors 4.png",
    "ORF.jpg",
    "sponsors 5.png",
    "sponsors 6.png",
    "sponsors 7.jpg",
  ];

  const partners = [
    "nokia_bell_logo.png",
    "col4.png",
    "col3.jpg",
    "col7.png",
    "col12.jpg",
    "col1.png",
    "raven_logo.jpg",
    "col6.jpg",
    "col8.png",
    "col9.png",
    "col10.png",
    "col11.png",
    "col13.png",
    "col14.jpg",
    "col15.jpg",
  ];

  const items = active === "sponsors" ? sponsors : partners;
  const colNum = active === "sponsors" ? { base: 2, md: 3 } : { base: 2, md: 4 };

  return (
    <Box bg={pageBg} minH="100vh">
      
      {/* ================= HERO HEADER ================= */}
      <Box
        pt={{ base: 6, md: 8 }}
        pb={{ base: 8, md: 10 }}
        bg={heroBg}
        borderBottom="1px solid"
        borderColor={border}
      >
        <Container maxW="1000px">
          <HStack spacing={2} flexWrap="wrap">
            <Tag
              size="lg"
              borderRadius="full"
              bg={useColorModeValue("white", "rgba(255,255,255,0.06)")}
              border="1px solid"
              borderColor={border}
              fontWeight="800"
            >
              University of Ottawa
            </Tag>

            <Tag
              size="lg"
              borderRadius="full"
              bg={useColorModeValue("rgba(34,197,94,0.14)", "rgba(34,197,94,0.18)")}
              color={useColorModeValue("#166534", "#86EFAC")}
              fontWeight="900"
            >
              NEXTCON Lab • SCVIC
            </Tag>
          </HStack>

          <Heading
            mt={4}
            fontSize={{ base: "3xl", md: "4xl" }}
            color={titleColor}
            letterSpacing="tight"
          >
            <Box
              as="span"
              bgClip="text"
              bgGradient={`linear(to-r, ${accent}, ${accent2})`}
            >
              Sponsors & Collaborators
            </Box>
          </Heading>

          <Text
            mt={3}
            color={subColor}
            fontSize={{ base: "md", md: "lg" }}
            maxW="85ch"
            lineHeight={1.8}
          >
            Strategic funding partners and research collaborators supporting
            NEXTCON Lab & SCVIC initiatives in intelligent transportation,
            edge intelligence, and next-generation communications.
          </Text>
        </Container>
      </Box>
      {/* ================================================= */}

      <Container maxW="1200px" py={10}>
        
        {/* TOGGLE SWITCH */}
        <Flex justify="center" mb={10}>
          <Box
            border="1px solid"
            borderColor={border}
            borderRadius="full"
            p="6px"                     // increased padding
            display="flex"
            gap={3}                     // more space between buttons
            bg={useColorModeValue("white", "rgba(255,255,255,0.05)")}
          >
            <Button
              borderRadius="full"
              variant={active === "sponsors" ? "solid" : "ghost"}
              bg={active === "sponsors" ? accent : "transparent"}
              color={active === "sponsors" ? "white" : titleColor}
              _hover={{ bg: active === "sponsors" ? accent : "rgba(34,197,94,0.15)" }}
              onClick={() => setActive("sponsors")}
            >
              Sponsors
            </Button>

            <Button
              borderRadius="full"
              variant={active === "partners" ? "solid" : "ghost"}
              bg={active === "partners" ? accent : "transparent"}
              color={active === "partners" ? "white" : titleColor}
              _hover={{ bg: active === "partners" ? accent : "rgba(34,197,94,0.15)" }}
              onClick={() => setActive("partners")}
            >
              Collaborators
            </Button>
          </Box>
        </Flex>

        {/* LOGO GRID */}
        <SimpleGrid columns={colNum} spacing={10}>
          {items.map((src, index) => (
            <Flex
              key={index}
              justify="center"
              align="center"
              p={6}
              border="1px solid"
              borderColor={border}
              borderRadius="18px"
              bg={useColorModeValue("white", "rgba(255,255,255,0.03)")}
              _hover={{
                transform: "translateY(-4px)",
                boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
                transition: "0.25s ease",
              }}
            >
              <Image
                src={src}
                alt=""
                maxH="110px"
                objectFit="contain"
              />
            </Flex>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

export default SponsorsPartners;